import { render, staticRenderFns } from "./loanDetail.vue?vue&type=template&id=5a911f30&scoped=true&"
import script from "./loanDetail.vue?vue&type=script&lang=js&"
export * from "./loanDetail.vue?vue&type=script&lang=js&"
import style0 from "./loanDetail.vue?vue&type=style&index=0&id=5a911f30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a911f30",
  null
  
)

export default component.exports